import * as React from 'react';

const MaintenanceIllustration = React.memo((): React.ReactElement => {
  return (
    <svg
      width="320"
      height="187"
      viewBox="0 0 320 187"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      data-testid="maintenance-illustration"
    >
      <ellipse cx="214" cy="149.6" rx="64.6667" ry="8.68214" fill="#0F2658" />
      <path
        d="M192.698 120.682L193.969 121.083C189.54 135.162 149.717 147.759 128.501 142.302L128.832 141.008C149.445 146.31 188.524 133.948 192.698 120.682Z"
        fill="#2969F2"
      />
      <path
        d="M201.278 126.928L199.489 138.603C199.489 138.603 190.68 143.386 196.874 143.526C203.067 143.667 232.244 143.526 232.244 143.526C232.244 143.526 237.887 143.526 228.941 138.462L227.152 126.225L201.278 126.928Z"
        fill="#2256C6"
      />
      <path
        d="M195.626 143.562C197.033 142.32 199.487 141.027 199.487 141.027L201.276 129.695L227.152 129.72L228.941 140.89C231.027 142.036 232.319 142.915 233.075 143.589C234.224 143.329 235.48 142.363 228.941 138.77L227.152 126.893L201.276 127.575L199.487 138.907C199.487 138.907 192.085 142.808 195.626 143.562Z"
        fill="#163984"
      />
      <path
        d="M155.333 58.8019C155.333 52.1458 160.72 46.75 167.364 46.75H260.636C267.28 46.75 272.667 52.1458 272.667 58.8019V116.844C272.667 123.501 267.28 128.896 260.636 128.896H167.364C160.72 128.896 155.333 123.501 155.333 116.844V58.8019Z"
        fill="#2256C6"
      />
      <path
        d="M159.333 59.8433C159.333 55.0301 163.242 51.1355 168.046 51.1613L259.596 51.6529C264.336 51.6783 268.176 55.5128 268.216 60.2604L268.667 112.867H159.333L159.333 59.8433Z"
        fill="#D3DFFB"
      />
      <path
        d="M272.667 117.543V124.748C272.667 125.848 272.232 126.904 271.459 127.682C270.685 128.46 269.635 128.897 268.541 128.897H159.459C158.365 128.897 157.315 128.46 156.541 127.682C155.768 126.904 155.333 125.848 155.333 124.748V117.543H272.667Z"
        fill="#2256C6"
      />
      <path
        d="M244.667 150.819V152.271H170V151.11L170.103 150.819L171.943 145.593H243.14L244.667 150.819Z"
        fill="#163984"
      />
      <path
        d="M273.295 149.698C273.161 150.279 272.655 150.892 271.514 151.472C267.417 153.551 259.086 150.917 259.086 150.917C259.086 150.917 252.667 149.808 252.667 146.897C252.847 146.771 253.035 146.658 253.229 146.557C254.952 145.632 260.663 143.349 270.79 146.654C271.537 146.891 272.203 147.335 272.715 147.934C273.126 148.422 273.448 149.04 273.295 149.698Z"
        fill="#2969F2"
      />
      <path
        d="M273.294 149.578C268.138 151.479 263.543 151.621 258.827 148.468C256.449 146.879 254.288 146.486 252.667 146.516C254.437 145.614 260.309 143.389 270.719 146.61C271.486 146.842 272.171 147.274 272.698 147.858C273.12 148.333 273.451 148.936 273.294 149.578Z"
        fill="#2256C6"
      />
      <ellipse
        cx="267"
        cy="148.265"
        rx="1.66667"
        ry="0.667857"
        fill="#608FF4"
      />
      <ellipse cx="214" cy="122.885" rx="2.66667" ry="2.67143" fill="#D3DFFB" />
      <path
        d="M96.1204 56.0448C100.521 55.3057 105.128 55.159 109.455 55.9807C119.007 57.7944 125.096 63.94 125.905 75.5347C126.511 84.2123 124.355 91.2161 119.893 98.6177C119.558 99.174 118.96 100.114 118.334 101.087L118.125 101.412C117.111 102.985 116.091 104.542 116.044 104.616C114.826 106.551 114.21 107.821 114.03 108.88C113.643 111.167 115.573 112.735 121.473 114.224L121.147 115.519C114.653 113.88 112.172 111.864 112.716 108.656C112.934 107.372 113.609 105.98 114.916 103.904C114.969 103.82 115.96 102.306 116.955 100.764L117.168 100.434C117.805 99.4449 118.416 98.4853 118.752 97.9272C123.083 90.7424 125.159 83.9972 124.575 75.6278C123.81 64.6708 118.191 58.9989 109.207 57.2931C105.057 56.505 100.599 56.647 96.3409 57.3621C95.5682 57.4919 94.8688 57.6309 94.2556 57.7696C94.0421 57.8179 93.8549 57.8626 93.6956 57.9026C93.6017 57.9262 93.539 57.9426 93.509 57.9508L93.1577 56.6623C93.1966 56.6517 93.2684 56.6328 93.3715 56.6069C93.5408 56.5644 93.7381 56.5173 93.962 56.4667C94.5987 56.3226 95.3224 56.1789 96.1204 56.0448Z"
        fill="#2969F2"
      />
      <path
        d="M118.063 119.074C119.4 118.837 120.8 118.791 122.13 119.056C125.119 119.653 127.054 121.708 127.305 125.479C127.488 128.241 126.834 130.475 125.492 132.818C125.397 132.983 125.235 133.253 125.062 133.536L124.931 133.75C124.647 134.211 124.375 134.648 124.365 134.666C124.038 135.213 123.877 135.561 123.836 135.812C123.772 136.21 124.147 136.53 125.664 136.933L125.322 138.224C123.225 137.667 122.313 136.888 122.52 135.599C122.595 135.132 122.812 134.663 123.221 133.979C123.252 133.928 124.079 132.601 124.335 132.153C125.557 130.021 126.138 128.036 125.974 125.568C125.765 122.42 124.286 120.849 121.869 120.366C120.726 120.138 119.482 120.179 118.294 120.389C118.078 120.427 117.884 120.468 117.714 120.508C117.615 120.532 117.548 120.55 117.517 120.558L117.149 119.275C117.331 119.222 117.645 119.147 118.063 119.074Z"
        fill="#2969F2"
      />
      <rect
        x="47.3333"
        y="34.7285"
        width="47.3333"
        height="55.4321"
        fill="#163984"
      />
      <rect
        x="42.6667"
        y="28.7178"
        width="57.3333"
        height="20.0357"
        fill="#2256C6"
      />
      <rect
        x="42.6667"
        y="52.0928"
        width="57.3333"
        height="20.0357"
        fill="#2256C6"
      />
      <rect
        x="42.6667"
        y="75.4678"
        width="57.3333"
        height="20.0357"
        fill="#2256C6"
      />
      <rect
        x="85.3333"
        y="32.7246"
        width="3.33333"
        height="3.33929"
        fill="#F77A5C"
      />
      <rect
        x="90"
        y="32.7246"
        width="3.33333"
        height="3.33929"
        fill="#F55C38"
      />
      <rect
        x="95.3333"
        y="32.7246"
        width="3.33333"
        height="3.33929"
        fill="#C84B2E"
      />
      <rect
        x="85.3333"
        y="55.4316"
        width="3.33333"
        height="3.33929"
        fill="#F77A5C"
      />
      <rect
        x="90"
        y="55.4316"
        width="3.33333"
        height="3.33929"
        fill="#F55C38"
      />
      <rect
        x="95.3333"
        y="55.4316"
        width="3.33333"
        height="3.33929"
        fill="#C84B2E"
      />
      <rect
        x="85.3333"
        y="78.8066"
        width="3.33333"
        height="3.33929"
        fill="#F77A5C"
      />
      <rect
        x="90"
        y="78.8066"
        width="3.33333"
        height="3.33929"
        fill="#F55C38"
      />
      <rect
        x="95.3333"
        y="78.8066"
        width="3.33333"
        height="3.33929"
        fill="#C84B2E"
      />
    </svg>
  );
});

MaintenanceIllustration.displayName = 'MaintenanceIllustration';

export { MaintenanceIllustration };
